import React, { Component, createRef } from 'react';
import ValidationText from "../../utils/validation/ValidationText.js";
import { CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { printFunction } from '../../components/print/printTemplate.js';

class PartyWiseDespatch extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            companyName: '',
            filterDetails: {
                startDate: "",
                endDate: "",
                partyName: "",
                totalSales: "",
            },
            partyWiseDespatchList: [],
            noItemFound: '',
            itemListing: [],
            totalCount: 0,
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllPartyWiseDespatchItem();
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    getAllPartyWiseDespatchItem = () => {
        let request = this.state.filterDetails
        this.despatchServices.getAllPartyWiseDespatchItem(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {

                let res = response.responseData
                if (res.gstInvoiceFinishGoodsResponse.length === 0) {
                    this.setState({ noItemFound: "No item found" });
                }
                const totalSum = res.gstInvoiceFinishGoodsResponse.reduce((sum, item) => sum + item.grandTotal, 0);
                let details = this.state.filterDetails
                details.totalSales = totalSum

                // let totalCount = res.itemListing.length

                this.setState({
                    partyWiseDespatchList: res.gstInvoiceFinishGoodsResponse,
                    filterDetails: details,
                    // itemListing: res.itemListing, 
                    // totalCount: totalCount
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyWiseDespatchItemById = (id, partyName) => {

        this.despatchServices.getAllPartyWiseDespatchItemById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let totalCount = res.length
                let details = this.state.filterDetails
                details.partyName = partyName
                this.setState({ itemListing: res, totalCount: totalCount, filterDetails: details }, () => {
                    this.getAllPartyWiseDespatchItem()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }


    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        Fdetails.partyName = ""
        Fdetails.totalSales = ""
        this.setState({
            filterDetails: Fdetails, totalCount: 0, noItemFound: '', partyWiseDespatchList: [], itemListing: []

        }, () => {
            this.getAllPartyWiseDespatchItem()
        });
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
            () => {
                if (name !== 'startDate' && name !== 'endDate') {
                    this.getAllPartyWiseDespatchItem()
                }
            }
        );
    };

    render() {
        return (
            <div className='paryWiseDespatchReport-page'>
                <div className="item-search flex gap-2.5 !mb-1.5 ">
                    <div className="input-grp  w-[27.5%]" >
                        <label>Start Date</label>
                        <input
                            className="inputFocus"
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp  w-[27.7%]">
                        <label>End Date</label>
                        <input
                            className="inputFocus"
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>

                    <div className="btn-grp mt-auto">
                        <button className={`add-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`} onClick={() => this.getAllPartyWiseDespatchItem()}>Search</button>

                        <button className={`cancel-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`} onClick={() => this.resetForm()}>Cancel</button>

                    </div>

                </div>
                <div className="item-search flex gap-2.5 !mb-2.5">
                    <div className="input-grp w-[35%]">
                        <label>Party Name</label>
                        <input
                            className="inputFocus"
                            type="text"
                            id="partyName"
                            name="partyName"
                            autoComplete="off"
                            value={this.state.filterDetails.partyName}
                            onChange={(event) =>
                                this.handleChange(event, "partyName")
                            }
                        />

                    </div>
                    <div className="input-grp w-[20.2%]">
                        <label>Total Sales</label>
                        <input
                            type="text"
                            id="totalSales"
                            name="totalSales"
                            disabled
                            autoComplete="off"
                            value={this.state.filterDetails.totalSales}
                            onChange={(event) =>
                                this.handleChange(event, "totalSales")
                            }
                        />
                    </div>
                    {this.state.itemListing && this.state.itemListing.length > 0 ?
                        <button className="print-btn mt-auto" onClick={() => printFunction()}>Print</button>
                        : null}
                </div>
                <div class="item-listing w-[56%]">
                    <div class="itemList-table">
                        <div class="table-container h-[24.5vh]" >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: "70%" }}>Party Name</td>
                                        <td style={{ width: "30%" }}>Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.partyWiseDespatchList && this.state.partyWiseDespatchList.length > 0 ? (
                                        this.state.partyWiseDespatchList.map((details, key) => (
                                            <tr
                                                key={key}
                                                tabIndex="0"
                                                className="hover:bg-gray-200 cursor-pointer focus:bg-gray-200"
                                                onClick={() =>
                                                    this.getAllPartyWiseDespatchItemById(details._id, details.partyId.partyName)
                                                }
                                            >
                                                <td>{details.partyId.partyName}</td>
                                                <td>{details.grandTotal}</td>
                                            </tr>
                                        ))
                                    ) : this.state.partyWiseDespatchList
                                        && this.state.partyWiseDespatchList.length === 0
                                        && this.state.noItemFound !== "" ? (
                                        <tr>
                                            <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.noItemFound}
                                            </td>
                                        </tr>
                                    ) : this.state.partyWiseDespatchList
                                        && this.state.partyWiseDespatchList.length === 0
                                        && this.state.noItemFound === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="table-upper mt-2.5">
                    <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                        Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
                    </p>
                </div>
                <div class="item-listing">
                    <div className="hidden print-title">
                        <h4 className="text-black font-semibold text-[18px]">Partywise Despatch</h4>
                        <p className="text-black">Party name:- {this.state.filterDetails.partyName}</p>
                    </div>
                    <div class="itemList-table">
                        <div class="table-container min-h-[44.5vh] max-h-[52vh]" >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[8%]'>Inv. No.</td>
                                        <td className='w-[8%]'>Date</td>
                                        <td className='w-[15%]'>Item Name</td>
                                        <td className='w-[8%]'>Batch No</td>
                                        <td className='w-[8%]'>Qty.</td>
                                        <td className='w-[6%]'>Free</td>
                                        <td className='w-[5%]'>Rate</td>
                                        <td className='w-[9%]'>Amount</td>
                                        <td className='w-[9%]'>Total Amount</td>
                                        <td className='w-[8%]'>Transp. Name</td>
                                        <td className='w-[8%] no-print'>L.R. No</td>
                                        <td className='w-[8%] no-print'>L.R. Date</td>
                                    </tr>
                                </thead>
                                <tbody className="print:!text-[12px] print:text-black">
                                    {this.state.itemListing && this.state.itemListing.length > 0 ? (
                                        this.state.itemListing.map((details, key) => (
                                            <tr key={key}>
                                                <td>{details.invoiceNo}</td>
                                                <td>{details.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : ''}</td>
                                                <td>{details.itemName}</td>
                                                <td>{details.batchNo}</td>
                                                <td>{details.qty}</td>
                                                <td>{details.free}</td>
                                                <td>{details.rate}</td>
                                                <td>{Number(details.taxableAmount) ? Number(details.taxableAmount).toFixed(2) : 0}</td>
                                                <td>{Number(details.grandTotal) ? Number(details.grandTotal).toFixed(2) : 0}</td>
                                                <td>{details.transportName}</td>
                                                <td className='no-print'>{details.lRNo}</td>
                                                <td className='no-print'>{details.lRDate ? moment(details.lRDate).format('DD MMM YYYY') : ''}</td>
                                            </tr>
                                        ))
                                    ) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Job Charges Report</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            {this.state.filterDetails.startDate !== "" && (
                                                <>
                                                    Start Date: <strong>{this.state.filterDetails.startDate}</strong>
                                                    <br />
                                                </>
                                            )}
                                            {this.state.filterDetails.endDate !== "" && (
                                                <>
                                                    End Date: <strong>{this.state.filterDetails.endDate}</strong>
                                                </>
                                            )}
                                            Party name: <strong>{this.state.filterDetails.partyName}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                                                      <div>
                                                                        <span className="info-label">Item Name:</span>
                                                                        <p className="info-value">Paracetamol</p>
                                                                      </div>
                                                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "24%" }} />
                                <col style={{ width: "8%" }} />
                                <col style={{ width: "6%" }} />
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "9%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "12%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Inv No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Date
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Item Name
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Batch No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Qty
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Free
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Rate
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Amount
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Total Amt
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Transp. Name
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.itemListing && this.state.itemListing.length > 0 ?
                                    this.state.itemListing.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.invoiceNo}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : ''}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.itemName}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.batchNo}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.qty}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.free}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.rate}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {Number(details.taxableAmount) ? Number(details.taxableAmount).toFixed(2) : 0}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {Number(details.grandTotal) ? Number(details.grandTotal).toFixed(2) : 0}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.transportName}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}

export default PartyWiseDespatch;